/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Dialog_Trial_End_Notification_ContentInputs */

const en_dialog_trial_end_notification_content = /** @type {(inputs: Dialog_Trial_End_Notification_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`We’ll send you a trial end push notification on ${i?.date}`)
};

const ar_dialog_trial_end_notification_content = /** @type {(inputs: Dialog_Trial_End_Notification_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`سنرسل إليك إشعارًا بنهاية التجربة في ${i?.date}`)
};

const de_dialog_trial_end_notification_content = /** @type {(inputs: Dialog_Trial_End_Notification_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Wir senden Ihnen eine Push-Benachrichtigung zum Ende der Testphase am ${i?.date}`)
};

const es_dialog_trial_end_notification_content = /** @type {(inputs: Dialog_Trial_End_Notification_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Te enviaremos una notificación de fin de prueba el día ${i?.date}`)
};

const fr_dialog_trial_end_notification_content = /** @type {(inputs: Dialog_Trial_End_Notification_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nous vous enverrons une notification pour vous rappeler la fin de votre essai le ${i?.date}`)
};

const it_dialog_trial_end_notification_content = /** @type {(inputs: Dialog_Trial_End_Notification_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ti invieremo una notifica push di fine prova il ${i?.date}`)
};

const ja_dialog_trial_end_notification_content = /** @type {(inputs: Dialog_Trial_End_Notification_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.date}にトライアル終了のプッシュ通知をお送りします`)
};

const ko_dialog_trial_end_notification_content = /** @type {(inputs: Dialog_Trial_End_Notification_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.date}에 푸시 알림으로 체험판 종료를 알려드려요`)
};

const pt_br_dialog_trial_end_notification_content = /** @type {(inputs: Dialog_Trial_End_Notification_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nós enviaremos uma notificação push sobre o encerramento do teste grátis em ${i?.date}`)
};

const ru_dialog_trial_end_notification_content = /** @type {(inputs: Dialog_Trial_End_Notification_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.date} мы отправим вам push-уведомление об окончании пробной версии`)
};

const th_dialog_trial_end_notification_content = /** @type {(inputs: Dialog_Trial_End_Notification_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`เราจะส่งการแจ้งเตือนการสิ้นสุดการทดลองใช้ให้คุณในวันที่ ${i?.date}`)
};

const tr_dialog_trial_end_notification_content = /** @type {(inputs: Dialog_Trial_End_Notification_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sana ${i?.date} tarihinde denemenin sonlanacağına dair bildirim göndereceğiz`)
};

const zh_cn_dialog_trial_end_notification_content = /** @type {(inputs: Dialog_Trial_End_Notification_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`我们会在 ${i?.date} 发送试用结束通知提醒你。`)
};

const zh_tw_dialog_trial_end_notification_content = /** @type {(inputs: Dialog_Trial_End_Notification_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`我們會在 ${i?.date} 發送試用結束通知提醒你。`)
};

/**
* | output |
* | --- |
* | "We’ll send you a trial end push notification on {date}" |
*
* @param {Dialog_Trial_End_Notification_ContentInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const dialog_trial_end_notification_content = /** @type {((inputs: Dialog_Trial_End_Notification_ContentInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Trial_End_Notification_ContentInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dialog_trial_end_notification_content(inputs)
	if (locale === "ar") return ar_dialog_trial_end_notification_content(inputs)
	if (locale === "de") return de_dialog_trial_end_notification_content(inputs)
	if (locale === "es") return es_dialog_trial_end_notification_content(inputs)
	if (locale === "fr") return fr_dialog_trial_end_notification_content(inputs)
	if (locale === "it") return it_dialog_trial_end_notification_content(inputs)
	if (locale === "ja") return ja_dialog_trial_end_notification_content(inputs)
	if (locale === "ko") return ko_dialog_trial_end_notification_content(inputs)
	if (locale === "pt_br") return pt_br_dialog_trial_end_notification_content(inputs)
	if (locale === "ru") return ru_dialog_trial_end_notification_content(inputs)
	if (locale === "th") return th_dialog_trial_end_notification_content(inputs)
	if (locale === "tr") return tr_dialog_trial_end_notification_content(inputs)
	if (locale === "zh_cn") return zh_cn_dialog_trial_end_notification_content(inputs)
	return zh_tw_dialog_trial_end_notification_content(inputs)
});